import { useEffect } from 'react'
import { CustomerAddress, OrderDelivery } from '@ancon/wildcat-types'
import useTranslation from 'next-translate/useTranslation'

import Modal from '../../../app/components/modal/Modal'
import {
  outletDetailsIdASelector,
  outletIsOutletDetailsPendingSelector,
  outletIsVisibleDeliveryLocationModalSelector,
  outletListItemSelector,
} from '../../../outlet/store/outletSelector'
import useAppSelector from '../../../../store/hooks/useAppSelector'
import useAppDispatch from '../../../../store/hooks/useAppDispatch'
import { fetchOutletDetails } from '../../../outlet/store/outletThunks'
import { checkoutCurrentCheckoutOutletListItemSelector } from '../../../checkout/store/checkoutSelectors'
import { outletSetIsVisibleDeliveryLocationModal } from '../../../outlet/store/outletSlice'
import DeliveryLocationConfigureForm from '../../forms/DeliveryLocationConfigureForm'

import DeliveryLocationConfigureModalSkeleton from './DeliveryLocationConfigureModalSkeleton'
import DeliveryLocationConfigureModalHeader from './DeliveryLocationConfigureModalHeader'
import styles from './DeliveryLocationConfigureModal.module.scss'

type DeliveryLocationConfigureModalProps = {
  initialAddress?: CustomerAddress | null
  isCheckoutPage?: boolean
  onClickContinue: (orderDelivery?: OrderDelivery) => void
}

export default function DeliveryLocationConfigureModal({
  initialAddress,
  isCheckoutPage = false,
  onClickContinue,
}: DeliveryLocationConfigureModalProps) {
  const { t } = useTranslation('common')

  const dispatch = useAppDispatch()

  const checkoutOutletListItem = useAppSelector(
    checkoutCurrentCheckoutOutletListItemSelector,
  )
  const outletListItem = useAppSelector(outletListItemSelector)
  const outletDetailsId = useAppSelector(outletDetailsIdASelector)
  const isOutletDetailsPending = useAppSelector(
    outletIsOutletDetailsPendingSelector,
  )
  const isOpen = useAppSelector(outletIsVisibleDeliveryLocationModalSelector)

  const outlet = isCheckoutPage ? checkoutOutletListItem : outletListItem

  // Fetch outlet details if not exists
  useEffect(() => {
    if (
      isOpen &&
      !isOutletDetailsPending &&
      outlet &&
      outlet.id !== outletDetailsId
    ) {
      dispatch(fetchOutletDetails({ outletId: outlet.id }))
    }
  }, [isOpen, outlet, outletDetailsId, dispatch, isOutletDetailsPending])

  function handleCloseModal() {
    dispatch(outletSetIsVisibleDeliveryLocationModal(false))
  }

  function handleContinue(orderDelivery?: OrderDelivery) {
    onClickContinue(orderDelivery)
    handleCloseModal()
  }

  return (
    <Modal
      isOpen={isOpen}
      title={t('components.deliveryLocationPickerModal.title')}
      CustomModalHeader={DeliveryLocationConfigureModalHeader}
      onClose={handleCloseModal}
      mobileModalMode="full-screen"
    >
      <div className={styles.modalContent}>
        {!isOutletDetailsPending ? (
          <DeliveryLocationConfigureForm
            initialAddress={initialAddress}
            enableInstructions={!!outlet?.enableCustomOrderNotesInAO}
            onContinue={handleContinue}
          />
        ) : (
          <DeliveryLocationConfigureModalSkeleton />
        )}
      </div>
    </Modal>
  )
}
